import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import ServiceCardFull from "../../components/ServiceCardFull/ServiceCardFull";

import "./ServicesFull.css";

const ServicesFull = ({ data }) => {
	const { t } = useTranslation();
	const items = t("services.items", { returnObjects: true });

	useEffect(() => {
		if (data["position"]) {
			const element = document.getElementById(data["position"]);
			element.scrollIntoView({
				block: "center",
				behavior: "smooth",
			});
		}
	}, [data]);

	return (
		<div className="services-full-bg">
			<h2 className="services-full-title">{t("services.title")}</h2>
			{items.map((item, index) => (
				<ServiceCardFull
					key={index}
					data={{
						id: index,
						icon: item["icon"],
						alt: item["alt"],
						name: item["title"],
						type: item["type"],
						description: item["descriptionFull"],
					}}
				/>
			))}
		</div>
	);
};

export default ServicesFull;
